import {Component, OnInit} from '@angular/core';
import {NotificationsService} from '../services/notifications.service';
import {Notification} from '../services/notification';
import {ApiResponse} from '@hassel-it/angular-common';
import {ActivatedRoute} from "@angular/router";
import {faMobileAlt} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  notifications: Notification[] = [];
  loading: boolean = false;
  page: number = 1;
  totalItems: number = 0;

  constructor(
    private notificationsService: NotificationsService,
    public activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
  }

  loadNotifications(page: number = 1): void {
    this.loading = true;
    this.notificationsService.getNotifications(page).then((response: ApiResponse) => {
      this.notifications = response.results;
      this.totalItems = response.count;
      this.page = page;
      this.loading = false;
    }).catch(err => {
      console.error('Error loading notifications', err);
      this.loading = false;
    });
  }

  markAsRead(notification: Notification): void {
    notification.is_read = true;
    this.notificationsService.updateNotification(notification).then(() => {
      // Notification updated
    }).catch(err => {
      console.error('Error updating notification', err);
    });
  }

    protected readonly faMobileAlt = faMobileAlt;
}
